// Feature 161: periodo della dashboard iniziale. Funzioni pure, testabili con un orologio fisso.

export type PeriodoDashboard = 'oggi' | '7' | '30';

export interface FinestraDashboard {
  /** Mezzanotte locale del primo giorno. */
  start: Date;
  /** Istante della richiesta. */
  end: Date;
}

export const PERIODI_DASHBOARD: { valore: PeriodoDashboard; etichetta: string }[] = [
  {valore: 'oggi', etichetta: 'Oggi'},
  {valore: '7', etichetta: '7 gg'},
  {valore: '30', etichetta: '30 gg'}
];

const GIORNI_INDIETRO: Record<PeriodoDashboard, number> = {oggi: 0, '7': 6, '30': 29};

export function isPeriodoDashboard(valore: unknown): valore is PeriodoDashboard {
  return valore === 'oggi' || valore === '7' || valore === '30';
}

/** «Oggi» da mezzanotte di oggi, «7 gg» da mezzanotte di 6 giorni fa, «30 gg» da 29 giorni fa; fine = adesso. */
export function finestra(periodo: PeriodoDashboard, adesso: Date): FinestraDashboard {
  const start = new Date(adesso.getFullYear(), adesso.getMonth(), adesso.getDate() - GIORNI_INDIETRO[periodo]);
  return {start, end: new Date(adesso.getTime())};
}

/** Variazione percentuale arrotondata; null se manca il riferimento (precedente 0). */
export function variazionePercentuale(attuale: number, precedente: number): number | null {
  if (!precedente) return null;
  return Math.round((attuale - precedente) / precedente * 100);
}

const GIORNO_QUERY = /^(\d{4})-(\d{2})-(\d{2})$/;

/** Giorno di un `EventiCounter.day` (mezzanotte locale) nel formato del query param `giorno` (YYYY-MM-DD). */
export function giornoQueryParam(giorno: Date | string): string {
  const d = new Date(giorno);
  const due = (n: number) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${due(d.getMonth() + 1)}-${due(d.getDate())}`;
}

/** Da `YYYY-MM-DD` all'intervallo locale 00:00:00 - 23:59:59; null se il valore non è un giorno valido. */
export function intervalloGiorno(valore: string | null | undefined): { da: Date; a: Date } | null {
  const parti = GIORNO_QUERY.exec(valore ?? '');
  if (!parti) return null;
  const [anno, mese, giorno] = [Number(parti[1]), Number(parti[2]) - 1, Number(parti[3])];
  const da = new Date(anno, mese, giorno, 0, 0, 0);
  if (da.getFullYear() !== anno || da.getMonth() !== mese || da.getDate() !== giorno) return null;
  return {da, a: new Date(anno, mese, giorno, 23, 59, 59)};
}
